import { useFrameCountQuery } from '@/hook';
import { SwapHoriz } from '@/package';
import { VIconButton } from '@/package';
import { useAuthStore } from '@/store';
import type { FrameData, Task } from '@/type';

import { ReviewerHandoffModalController } from './ReviewerHandoffModalController';

export const ReviewerHandoffEachButton = ({
  frameSeq,
  task,
}: {
  frameSeq: FrameData['frameSeq'][];
  task: Task;
}) => {
  const { user, isManager } = useAuthStore();
  const { data: assignedCount } = useFrameCountQuery({
    taskID: task.id,
    workState: ['Reviewing'],
    reviewerID: [user.id],
  });

  return (
    <ReviewerHandoffModalController
      frameSeq={frameSeq}
      handoffType="each"
      taskID={task.id}
    >
      <VIconButton
        Icon={SwapHoriz}
        className="text-primary-500!"
        disabled={!assignedCount || !isManager()}
        size="sm"
        type="button"
        variant="roundSecondary"
      />
    </ReviewerHandoffModalController>
  );
};

ReviewerHandoffEachButton.displayName = 'ReviewerHandoffEachButton';
